import { determineFullTradeData } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import React from "react";

const ReferenceRatesCellRenderer = (params: any) => {
  //Only for OP
  const fullTradeData = determineFullTradeData(params);

  if (
    !fullTradeData.referenceRates ||
    fullTradeData.referenceRates.length == 0 ||
    !fullTradeData.referenceRates[0].referenceRateCode ||
    !fullTradeData.referenceRates[0].referenceRate ||
    fullTradeData.referenceRates[0].referenceRate.length == 0 ||
    !fullTradeData.referenceRates[0].referenceRate[0].rate
  ) {
    return;
  }
  const rateToReturn = fullTradeData.referenceRates[0].referenceRate[0].rate;
  const notationToReturn =
    fullTradeData.referenceRates[0].referenceRate[0].notation;

  return (
    <div>
      {rateToReturn} {notationToReturn}
    </div>
  );
};

export default ReferenceRatesCellRenderer;
